const defaultTranslations: any = {
    shipping_label: "shipping",
    subscription_plan_nonprepaid_label: "Deliver every {{delivery_interval}}",
    subscription_plan_prepaid_label:
        "Pay every {{billing_interval}}, deliver every {{delivery_interval}}",
    subscription_details_view_details_button: "View details",
    order_to_be_charged_before_delivery_label:
        "Order to be charged {{chargeOffset}} days before delivery",
    next_order_date_label: "Next order:",
    next_order_card_date_label: "Next order:",
    end_of_list_label: "End of list",
    choose_product_options_label: "Choose product options",
    quantity_label: "Quantity",
    go_back_button: "Go back",
    cp_logout_button: "Logout",
    cp_logout_modal_title: "Logout",
    cp_logout_modal_body: "Are you sure you want to logout?",
    cp_logout_modal_confirm_button: "Confirm",
    cp_logout_modal_cancel_button: "Close",
    error_message: "Some error occurred",
    quick_action_completed_message: "This quick action link has expired",
    campaign_action_completed_message: "This campaign link has expired",
    subscription_listing_active_subscriptions_header: "Active Subscriptions",
    subscription_listing_inactive_subscriptions_header:
        "Inactive/ Completed Subscriptions",
    subscription_listing_view_details_button: "View details",
    subscription_listing_no_active_subscriptions_text:
        "You don't have any active subscriptions",
    subscription_listing_create_payment_failed_label: "Payment method expired",
    subscription_listing_create_last_billing_failed_label:
        "Last billing failed",
    subscription_listing_create_button: "Add new subscription",
    subscription_listing_merge_button: "Merge subscriptions",
    subscription_listing_refresh_button: "Refresh",
    subscription_listing_multipass_button: "Go to your Shopify account",
    payment_expired_banner_header: "Payment method expired",
    payment_expired_banner_body_text: "Please update your payment method",
    payment_failed_banner_header: "Payment failed",
    payment_expired_banner_update_button_text: "Update",
    payment_failed_banner_last_mail_sent_text: "Last mail sent on:",
    payment_failed_banner_send_again_button_text: "Send again",
    pause_subscription_button: "Pause subscription",
    resume_subscription_button: "Resume subscription",
    cancel_subscription_button: "Cancel subscription",
    reactivate_subscription_button: "Reactivate subscription",
    view_scheduled_orders_button: "View scheduled orders",
    view_order_history_button: "View past orders",
    subscription_details_header: "Subscription details",
    order_now_button: "Order now",
    order_now_popup_header: "Order now",
    order_now_popup_warning_text: "You have placed an order within last 24 hours.",
    order_now_popup_body: "Are you sure that you want to order now?",
    order_now_popup_out_of_stock_text:
        "Few item(s) in your order are currently out of stock and hence the order cannot be placed. We regret the inconvenience caused at your end.",
    order_now_popup_confirm_button: "Confirm",
    order_now_popup_cancel_button: "Cancel",
    order_now_success_message: "New order placed successfully.",
    skip_order_button: "Skip order",
    skip_order_popup_header: "Skip order",
    skip_order_popup_body: "Are you sure that you want to skip the order?",
    skip_order_popup_confirm_button: "Confirm",
    skip_order_popup_cancel_button: "Cancel",
    skip_order_success_message: "Order has been skipped.",
    unskip_order_popup_header: "Unskip order",
    unskip_order_popup_body: "Are you sure that you want to unskip the order?",
    unskip_order_success_message: "Order has been unskipped.",
    unskip_order_popup_confirm_button: "Confirm",
    unskip_order_popup_cancel_button: "Cancel",
    reschedule_order_button: "Re-schedule",
    reschedule_order_drawer_header: "Reschedule order",
    reschedule_order_drawer_confirm_button: "Confirm",
    reschedule_order_drawer_cancel_button: "Cancel",
    reschedule_order_success_message: "Subscription has been rescheduled.",
    delay_order_button: "Delay",
    delay_order_drawer_header: "Delay subscription",
    delay_order_drawer_body:
        "Please select by how many days you want to delay your next order",
    delay_order_custom_option_label: "Custom:",
    delay_order_drawer_confirm_button: "Confirm",
    delay_order_drawer_cancel_button: "Cancel",
    delay_order_drawer_days_label: "Days",
    delay_order_success_message:
        "Subscription has been deplayed by {{days}} days.",
    upsell_header: "Goes well with your next order...",
    upsell_add_button: "Add",
    upsell_all_products_button: "See more products",
    product_card_subscription_discount_label: "Subscription discount",
    product_card_one_time_discount_label: "One time discount",
    product_card_edit_button: "Edit",
    product_card_one_time_added_label: "One time added",
    product_card_one_time_removed_label: "One time removed",
    product_card_out_of_stock_label: "Out of stock",
    discount_header: "Discount code",
    discount_apply_button: "Apply",
    discount_placeholder: "Discount code",
    discount_add_success_message: "Discount code added successfully.",
    remove_discount_popup_header_text: "Remove discount",
    remove_discount_popup_body_text:
        "Are you sure that you want to remove the discount '{{discount_code}}'?",
    remove_discount_popup_confirm_button: "Confirm",
    remove_discount_popup_cancel_button: "Cancel",
    remove_discount_popup_success_message: "Discount code removed successfully",
    frequency_header: "Subscription plan",
    frequency_edit_button: "Edit",
    frequency_edit_drawer_header: "Edit plan",
    frequency_edit_drawer_body: "Please select the new plan",
    frequency_option_label: "Deliver every {{delivery_interval}}",
    frequency_option_prepaid_label:
        "Pay every {{billing_interval}}, deliver every {{delivery_interval}}",
    frequency_edit_drawer_confirm_button: "Confirm",
    frequency_edit_drawer_cancel_button: "Cancel",
    frequency_edit_success_message: "Subscription plan has been updated.",
    frequency_edit_next_order_date: "Next order date",
    frequency_edit_next_order_date_drawer_header: "Select next order date",
    frequency_edit_next_order_date_select_button: "Select",
    shipping_header: "Shipping address",
    shipping_address_na: "N/A",
    shipping_edit_button: "Edit",
    shipping_edit_drawer_header: "Edit shipping address",
    shipping_first_name_label: "First name",
    shipping_last_name_label: "Last name",
    shipping_phone_label: "Phone number",
    company_label: "Company",
    shipping_address_label: "Address",
    shipping_apartment_label: "Apartment, suite, etc.",
    shipping_city_label: "City",
    shipping_zip_label: "Zip",
    shipping_country_label: "Country",
    shipping_province_label: "Province",
    shipping_edit_drawer_save_button: "Confirm",
    shipping_edit_drawer_cancel_button: "Cancel",
    shipping_apply_on_all_contracts_text:
        "Apply this shipping address to all your subscriptions",
    shipping_edit_success_message: "Shipping address has been updated.",
    payment_header: "Payment details",
    payment_card_details_text: "{{card_brand}} ending in {{last_digits}}",
    payment_card_expiry_text: "Expires {{expiryMonth}}/{{expiryYear}}",
    paypal_account_with_email_text: "PayPal account: {{email}}",
    paypal_account_without_email_text: "PayPal billing agreement",
    payment_last_updated_label: "Last updated on:",
    payment_last_mail_sent_label: "Last update mail sent on:",
    payment_revoked_label: "Revoked",
    payment_update_button: "Update",
    payment_change_button: "Change",
    shipping_address_popup_header: "Shipping address updated",
    shipping_address_popup_body: "Do you want to set this shipping address for all your subscriptions?",
    shipping_address_popup_confirm_button: "Confirm",
    shipping_address_popup_cancel_button: "Later",

    // payments nex texts
    payment_manage_button: "Manage",
    payment_manage_drawer_header: "Manage payment methods",

    payment_method_primary: "Primary",
    payment_set_as_primary_button: "Set as primary",
    payment_method_set_as_primary_success: "Primary payment method updated!",
    payment_method_apply_all_contracts_header_text: "Primary method updated",
    payment_method_apply_all_contracts_body_text: "Do you want to set this card as primary payment method on all your subscriptions?",
    payment_method_apply_all_contracts_cancel_btn_text: "Later",
    payment_method_apply_all_contracts_confirm_btn_text: "Confirm",

    payment_add_backup_button: "Add backup",
    payment_method_add_backup_drawer_title: "Add backup card",
    payment_method_add_backup_drawer_body: "Add a backup card to ensure there are no interruptions to your subscription. Backup payment method will be used if the primary method fails on the first attempt.",
    payment_method_add_backup_drawer_confirm_button: "Add backup card",
    payment_method_add_backup_drawer_cancel_button: "Go back",
    payment_method_backup_added_success: "Backup card added!",

    payment_method_backup: "Backup",
    payment_set_as_backup_button: "Set as backup",
    payment_method_backup_updated_success: "Backup payment method updated!",
    payment_remove_as_backup_button: "Remove as backup",
    payment_method_backup_removed_success: "Backup payment method removed!",

    payment_manage_drawer_delete_button: "Delete",
    payment_method_delete_popup_header: "Delete payment method",
    payment_method_delete_popup_body: "Are you sure you want to delete this payment method?",
    payment_method_delete_popup_confirm_button: "Delete",
    payment_method_delete_popup_cancel_button: "Cancel",
    payment_method_delete_success: "Payment method deleted!",

    payment_change_drawer_add_button: "Add card",
    payment_change_drawer_add_header: "Add new card",
    payment_change_drawer_update_header: "Update card details",

    add_payment_method_nameOnCard: "Name on card",
    add_payment_method_cardNumber: "Card number",
    add_payment_method_expiry: "Expires",
    add_payment_method_cvv: "CVV",
    add_payment_method_countryRegion: "Country/ Region",
    add_payment_method_firstName: "First name",
    add_payment_method_lastName: "Last name",
    add_payment_method_address: "Address",
    add_payment_method_city: "City",
    add_payment_method_state: "State",
    add_payment_method_pin: "Zip/Postal code",

    use_existing_billing_address_label: "Billing address is same",
    add_payment_method_card_number_placeholder: "1234 1234 1234 1234",
    add_payment_method_name_on_card_placeholder: "Full name on card",

    add_payment_method_drawer_description: "",
    add_payment_method_card_details_header: "Card details",
    add_payment_method_billing_details_header: "Billing address",
    add_payment_method_add_card_btn: "Add card",
    update_payment_method_add_card_btn: "Update card",
    update_payment_method_and_order_now: "Update card and place order",
    payment_change_drawer_error_header_text: "Please fix the below errors",
    payment_method_added: "Payment method added successfully",
    payment_method_updated: "Payment method updated successfully",

    payment_expiring_soon_label: "Expiring soon",
    payment_expired_label: "Expired",
    payment_instrument_not_found: "No payment method added",
    payment_instrument_revoked_text: "Payment method revoked",
    payment_update_popup_header: "Update payment details",
    payment_update_popup_body:
        "You will receive an email with a secured link to update your payment details.",
    payment_update_popup_confirm_button: "Confirm",
    payment_update_popup_cancel_button: "Cancel",
    payment_update_success_message:
        "Payment update mail sent. Please check your inbox.",
    payment_change_drawer_header: "Select payment method",
    payment_change_drawer_apply_on_all_contracts_text:
        "Apply this payment method to all your subscriptions",
    payment_change_drawer_save_button: "Change to this payment method",
    payment_change_drawer_cancel_button: "Cancel",
    payment_change_success_message: "Payment details have been updated.",
    interval_single_day: "day",
    interval_multiple_days: "{{number}} days",
    interval_single_week: "week",
    interval_multiple_weeks: "{{number}} weeks",
    interval_single_month: "month",
    interval_multiple_months: "{{number}} months",
    interval_single_year: "year",
    interval_multiple_years: "{{number}} years",
    order_status_paid: "Paid",
    financial_status_pending: "Pending",
    financial_status_authorized: "Authorized",
    financial_status_partially_paid: "Partially Paid",
    financial_status_partially_refunded: "Partially Refunded",
    financial_status_refunded: "Refunded",
    financial_status_voided: "Voided",
    order_status_failed: "Failed",
    order_status_scheduled: "Scheduled",
    order_status_processing: "Order processing",
    order_status_skipped: "Skipped",
    subscription_status_active: "Active",
    subscription_status_cancelled: "Cancelled",
    subscription_status_expired: "Expired",
    subscription_status_paused: "Paused",
    subscription_status_inprogress: "In Progress",
    gift_subscription_status_active: "Active",
    gift_subscription_status_cancelled: "Cancelled",
    gift_subscription_status_expired: "Completed",
    gift_subscription_status_paused: "Paused",
    gift_subscription_status_inprogress: "In Progress",
    add_product_drawer_header: "Add product",
    add_product_purchase_options_label: "Purchase options",
    add_one_time_option_label: "Add one-time",
    add_one_time_option_with_discount_label:
        "Add one-time, Save {{discount_amount}}",
    add_subscription_with_discount_label:
        "Add subscription, Save {{discount_amount}}",
    add_subscription_without_discount_label: "Add subscription",
    add_one_time_confirm_button: "Add One-time",
    out_of_stock_button: "Out of stock",
    add_one_time_confirm_with_discount_button:
        "Add One-time, {{discount_amount}}",
    add_subscription_with_discount_confirm_button:
        "Add subscription, Save {{discount_amount}}",
    add_subscription_without_discount_confirm_button: "Add Subscription",
    add_subscription_cancel_button: "Cancel",
    add_product_success_message:
        "{{product_name}} has been added to subscription.",
    add_product_new_subscription_success_message:
        "New subscription created successfully.",
    add_product_onetime_success_message:
        "{{product_name}} has been added to the next order.",
    select_product_drawer_header: "Select product",
    select_product_search_placeholder: "Search",
    select_product_search_button: "Search",
    select_product_select_button: "Select",
    select_product_no_products_found: "No results found",
    edit_product_drawer_header: "Edit product",
    edit_product_drawer_cannot_swap: "This product canot be swapped",
    edit_product_confirm_button: "Update",
    edit_product_swap_button: "Swap",
    edit_product_cancel_button: "Cancel",
    edit_product_remove_button: "Remove",
    edit_product_confirm_swap_button: "Confirm swap",
    edit_product_choose_another_product_button: "Choose another product",
    edit_product_success_message: "{{product_name}} quantity has been updated.",
    edit_product_remove_success_message:
        "{{product_name}} has been removed from the subscription.",
    edit_product_remove_onetime_success_message:
        "{{product_name}} has been removed from the upcoming order.",
    edit_product_swap_success_message: "{{product_name}} has been updated.",
    edit_product_swap_cancellation_success_message:
        "Products have been swapped successfully.",
    edit_product_remove_drawer_header: "Remove product",
    edit_product_remove_drawer_body_text:
        "Are you sure that you want to remove this product?",
    edit_product_remove_drawer_one_time_button: "Remove one time",
    edit_product_remove_drawer_subscription_button: "Remove from Subscription",
    edit_product_remove_drawer_cancel_button: "Cancel",
    edit_product_variant_not_found_option_placeholder: "Select",
    edit_product_remove_line_inv_disc_error_message:
        'Remove "{{discount_code}}" discount first to complete this operation.',
    undo_onetime_remove_success_message:
        "The product was added back to the subscription",
    view_scheduled_orders_drawer_header: "Order schedule",
    view_scheduled_orders_drawer_no_orders: "No orders found",
    view_scheduled_orders_skip_button: "Skip",
    view_scheduled_orders_unskip_button: "Unskip",
    order_history_drawer_header: "Order history",
    delivery_date_order_history_label: "Delivery date:",
    charge_date_order_history_label: "Charge date:",
    order_history_drawer_no_orders: "No orders found",
    order_history_order_label: "Order",
    order_history_show_details_button: "Show details",
    order_history_hide_details_button: "Hide details",
    order_history_items_total_label: "Items total",
    order_history_discounts_label: "Discounts",
    order_history_shipping_label: "Shipping",
    order_history_taxes_label: "Taxes",
    order_history_shipping_address_label: "Shipping address",
    order_history_shipping_address_not_available: "N/A",
    pause_subscription_popup_header: "Pause subscription",
    pause_subscription_popup_body:
        "Are you sure that you want to pause the subscription?",
    pause_subscription_confirm_button: "Confirm",
    pause_subscription_cancel_button: "Cancel",
    pause_subscription_success_message: "Subscription has been paused.",
    resume_subscription_popup_header: "Resume subscription",
    resume_subscription_popup_body:
        "Are you sure that you want to resume the subscription?",
    resume_subscription_confirm_button: "Confirm",
    resume_subscription_cancel_button: "Cancel",
    resume_subscription_success_message: "Subscription has been resumed.",
    reactivate_subscription_popup_header: "Reactivate subscription",
    reactivate_subscription_popup_body:
        "Are you sure that you want to reactivate the subscription?",
    reactivate_subscription_confirm_button: "Confirm",
    reactivate_subscription_cancel_button: "Cancel",
    reactivate_subscription_success_message:
        "Subscription has been reactivated.",
    cancel_subscription_drawer_header: "Cancel subscription",
    cancel_subscription_select_reason_help_text:
        "Select a reason for cancelling your subscription?",
    cancel_subscription_select_reason_help_text_optional:
        "Select a reason for cancelling your subscription (optional)?",
    cancel_subscription_proceed_button: "Proceed",
    cancel_subscription_keep_subscritpion_button: "Keep subscription",
    cancel_subscription_delay_order_button: "Delay",
    cancel_subscription_skip_order_button: "Skip",
    cancel_subscription_swap_product_button: "Swap",
    cancel_subscription_pause_subscription_button: "Pause",
    cancel_subscription_bubblehouse_redeem_loyalty_points:
        "Redeem loyalty points",
    cancel_subscription_friendbuy_redeem_loyalty_points:
        "Redeem loyalty points",
    cancel_subscription_influence_redeem_loyalty_points:
        "Redeem loyalty points",
    cancel_subscription_yotpo_redeem_loyalty_points: "Redeem points",
    cancel_subscription_rivo_redeem_loyalty_points: "Redeem points",
    cancel_subscription_riseai_redeem_loyalty_points: "Redeem credits",
    cancel_subscription_okendo_redeem_loyalty_points: "Redeem credits",
    cancel_subscription_continue_to_cancel_button:
        "I still want to cancel my subscription",
    cancel_subscription_remarks_text:
        "Any remarks or suggestions to help us provide you better subscription experience next time?",
    cancel_subscription_confirm_cancel_button: "Cancel subscription",
    cancel_subscription_swap_drawer_header: "Swap products",
    cancel_subscription_swap_confirm_button: "Confirm",
    cancel_subscription_swap_cancel_button: "Cancel",
    cancel_subscription_swap_swapped_with_label: "Swapped with:",
    cancel_subscription_success_message: "Subscription has been cancelled.",
    subscription_login_expiry_header: "Subscription Login Link Expired",
    subscription_login_expiry_body:
        "Hey, the subscription login link you are trying to access has expired. Click the button below to receive a new magic link to your email that will sign you in instantly.",
    subscription_login_expiry_submit: "Regenerate login link",
    subscription_login_expiry_try_again_button:
        "Didn't receive the email? Try again",
    subscription_login_expiry_contact_support_button:
        "In case of any issues, please reach out to our support",
    subscription_login_expiry_success_message:
        "Login link sent successfully to {{email}}",
    month_jan: "January",
    month_feb: "February",
    month_mar: "March",
    month_apr: "April",
    month_may: "May",
    month_jun: "June",
    month_jul: "July",
    month_aug: "August",
    month_sep: "September",
    month_oct: "October",
    month_nov: "November",
    month_dec: "December",
    cp_cancellation_flow_min_orders_title: "Cancel subscription",
    cp_cancellation_flow_min_orders_body:
        "Your cancellation request cannot be completed as you are still {{min_orders_left}} orders away from fulfilling the minimum orders requirement.",
    cp_cancellation_flow_min_orders_btn_text: "Cancel",
    cancel_subscription_update_delivery_frequency_button:
        "Update delivery frequency",
    cp_cancellation_flow_instructions_title: "Cancel subscription",
    cp_cancellation_flow_instructions_body: "",
    cp_cancellation_flow_instructions_btn_text: "Close",
    subscription_create_drawer_title: "Add new subscription",
    subscription_create_product_title: "Product",
    subscription_create_change_product_btn: "Change product",
    subscription_create_product_options: "Product options",
    subscription_create_quantity_label: "Quantity",
    subscription_create_drawer_start_btn: "Start subscription",
    subscription_create_drawer_close_btn: "Close",
    subscription_create_drawer_frequency_label: "Select subscription frequency",
    subscription_create_drawer_start_date_label: "Subscription start date",
    subscription_create_drawer_start_date_header: "Set start date",
    subscription_create_drawer_start_date_body:
        "Choose the start date for your subscription",
    subscription_create_drawer_start_date_confirm_button: "Confirm date",
    subscription_create_drawer_payment_method_label: "Select payment method",
    subscription_create_drawer_shipping_address_label:
        "Select shipping address",
    subscription_create_drawer_edit_shipping_address_btn: "Edit",
    subscription_create_success_message:
        "New subscription created successfully.",
    merge_subscriptions_drawer_title: "Merge subscriptions",
    merge_subscription_body:
        "We have found the following subscriptions which share the same frequency interval, and are shipped to the same delivery address. You can choose to merge them in a single subscription saving you the shipping costs associated with the separate orders.",
    merge_subscription_shipping_address_title:
        "Select a shipping address to merge",
    merge_subscription_count_label: "{{subscriptions_count}} subscriptions",
    merge_subscription_next_button: "Next",
    merge_subscription_cancel_button: "Cancel",
    merge_subscription_subscriptions_to_merge_label: "Subscriptions to merge",
    merge_subscription_show_product_details: "View product details",
    merge_subscription_hide_product_details: "Hide product details",
    merge_subscription_choose_order_date_button: "Choose order date",
    merge_subscriptions_order_date_drawer_title: "Set order date",
    merge_subscription_choose_order_date_body:
        "Choose the next order date for the combined subscription",
    merge_subscription_success_message: "Subscriptions merged successfully",
    off_label: "off",
    cancel_subscription_discount_incentive_success:
        "Discount applied successfully",
    error_msg_minimum_amount_product_add:
        "Product cannot be removed as minimum subscription value should be above {{currency}}{{min_amount}}",
    error_msg_minimum_weight_line_edit:
        "Product cannot be removed as minimum order weight should be above {{minimum_order_weight}}",
    error_msg_invalid_discount_code: "Invalid discount code",
    error_msg_discount_present: "Cannot add more than 1 discount code.",
    login_page_title: "Request Subscription Login Link",
    login_page_description:
        "<p>Provide your email below which you used for purchasing the subscription. We will send a magic link to your email that will sign you in instantly.</p>",
    login_confirm_btn: "Send Subscription Login Link",
    login_customer_support_btn:
        "Didn't receive the email? Reach out to our support",
    login_invalid_email_msg: "Invalid email",
    login_mail_success_msg: "Mail sent successfully",
    login_customer_invalid_msg: "Customer not found",
    login_email_field: "Email address",
    important_links_header: "Important links",
    important_links_multipass_link: "Go to your Shopify account",
    order_notes_card_header: "Order notes",
    order_notes_card_edit_btn: "Edit",
    order_notes_drawer_header: "Edit order notes",
    order_notes_drawer_input_label: "Order note:",
    order_notes_drawer_confirm_btn: "Confirm",
    order_notes_drawer_close_btn: "Close",
    order_notes_drawer_success_msg: "Order notes updated successfully.",
    local_delivery_card_header: "Local delivery address",
    local_delivery_card_address_na: "N/A",
    local_delivery_card_edit_button: "Edit",
    change_delivery_method_button: "Change delivery method",
    local_delivery_edit_drawer_header: "Edit local delivery address",
    local_delivery_instructions_label: "LD Instructions",
    local_delivery_edit_success_message:
        "Local delivery address has been updated.",
    pickup_card_header: "Pickup locations",
    pickup_card_address_na: "N/A",
    pickup_card_edit_button: "Edit",
    pickup_edit_drawer_header: "Change pickup location",
    pickup_edit_success_message: "Pickup address has been updated.",
    select_customer_address_drawer_header: "Select address",
    select_customer_address_drawer_confirm_button: "Select address",
    select_customer_address_drawer_close_button: "Close",
    delivery_method_add_new_address_btn: "Add new address",
    add_address_drawer_header: "Add address",
    available_delivery_options_header: "Available delivery methods",
    no_delivery_options_available: "No delivery options available",
    change_delivery_method_to_shipping: "Shipping",
    change_delivery_method_to_local_delivery: "Local delivery",
    change_delivery_method_to_pickup: "Pickup",
    change_delivery_method_save_button: "Change delivery method",
    change_delivery_method_cancel_button: "Close",
    delivery_method_updated_to_shipping_success_message:
        "Delivery method updated to shipping successfully",
    delivery_method_updated_to_local_delivery_success_message:
        "Delivery method updated to local delivery successfully",
    delivery_method_updated_to_pickup_success_message:
        "Delivery method updated to pickup successfully",
    build_your_bundle_with_percentage_fixed_discount:
        "Up to {{discount_value}} off",
    build_your_bundle_with_fixed_amount_per_item_discount:
        "Up to {{discount_value}} off each item",
    add_subscription_not_allowed_text:
        "This item cannot be added as a subscription",
    add_one_time_not_allowed_text: "This item cannot be added as a one-time",
    mark_for_cancellation_message_text:
        "The subscription will be cancelled after {{remainingOrders}} orders.",
    mark_cancel_success_message: "Your subscription will not be auto-renewed.",
    loyalty_widget_btn: "{{points}} Loyalty points | {{coupons}} coupons",
    loyalty_overview_drawer_header: "Rewards for your commitments!",
    loyalty_overview_drawer_go_back_btn: "Go back",
    loyalty_overview_points_title: "Points available",
    loyalty_overview_coupons_title: "Coupons available",
    loyalty_overview_discount_btn: "Redeem your discount coupons",
    loyalty_overview_discount_btn_subtitle: "{{coupons}} coupons available",
    loyalty_overview_description: "",
    loyalty_overview_redeem_btn: "Redeem your points",
    loyalty_overview_redeem_btn_subtitle: "{{points}} points available",
    loyalty_discounts_drawer_header: "Avail existing rewards",
    loyalty_discounts_drawer_go_back_btn: "Go back",
    loyalty_discounts_available_coupons_text: "{{coupons}} coupons available",
    loyalty_discounts_drawer_apply_btn: "Apply",
    loyalty_points_drawer_header: "Redeem your points",
    loyalty_points_drawer_go_back_btn: "Go back",
    loyalty_points_drawer_available_points_label: "{{points}} points available",
    loyalty_points_drawer_slider_description:
        "Use the slider to exchange points for store discount. {{conversion_points}} points = {{conversion_rate}}. Min points required for redemption: {{min_points}}. Max points required for redemption: {{max_points}}",
    loyalty_points_drawer_redeem_btn: "Redeem",
    loyalty_points_drawer_redeem_value_label: "{{value}} off",
    loyalty_points_drawer_points_redeemed_label: "Points redeemed",
    loyalty_points_drawer_discount_description:
        "Copy the code to enter during checkout",
    loyalty_points_drawer_bucket_points_label: "{{points}} Point",
    loyalty_discounts_drawer_discount_subtitle: "{{value}} off",
    loyalty_points_drawer_selected_label:
        "{{points}} points = {{points_amount}}",
    create_subscription_next_button_text: "Next",
    choose_add_product_subscription_drawer_header: "Add subscription product",
    chose_existing_subscription_body_text:
        "You already have {{matching_subscription_count}} active subscriptions on the same frequency and address. Add to your existing subscription and enjoy a seamless ordering experience.",
    add_to_existing_subscription_btn: "Add to existing subscription",
    add_to_new_subscription_btn: "Create new subscription",
    add_product_to_subscription_btn_text: "Add to subscription",
    create_new_subscription_v2_header: "Create new subscription header",
    create_new_subscription_description:
        "Please select the subscription start date and payment method for the new subscription",
    choose_from_existing_subscription_drawer_header:
        "Select from existing subscription",
    choose_from_existing_subscription_drawer_body:
        "Select the existing subscription in which you want to add the product",
    card_declined: "Your card was declined.",
    insufficient_funds: "Your card has insufficient funds.",
    card_expired: "Your card has expired.",
    agreement_cancelled:
        "Your billing agreement was canceled or revoked. Try using an alternative payment method.",
    card_not_supported:
        "Your card is not accepted for payment. Try using an alternative payment method.",
    card_invalid: "Your card is invalid.",
    paypal_error:
        "Some error occured. Please update the payment details on your PayPal account.",
    gateway_issue:
        "Unable to process the payment. Contact the support team for help.",
    payment_revoked:
        "Payment method was revoked. Try using an alternative payment method.",
    shoppay_not_enabled:
        "Shop pay wallet is not enabled for payment. Try using an alternative payment method.",
    not_confirmed_payments: "Payment marked as failed due to non-confirmation.",
    manage_subscription_CTA: "Manage subscription",
    cp_thank_gifter_CTA_without_gifter_name: "Thank gifter",
    cp_thank_gifter_CTA_with_gifter_name: "Thank {{gifter_name}}",
    cp_gift_message_box_title_without_gifter_name: "Message",
    cp_gift_message_box_title_with_gifter_name: "Message from {{gifter_name}}",
    discard_CTA: "Discard",
    send_message_CTA: "Send message",
    message_input_placeholder:
        "Write your thank you message. We will deliver it on your behalf!",
    thank_gifter_box_title_without_gifter_name: "Thank gifter",
    thank_gifter_box_title_with_gifter_name: "Thank {{gifter_name}}",
    thank_gifter_CTA_without_gifter_name: "Thank gifter",
    thank_gifter_CTA_with_gifter_name: "Thank {{gifter_name}}",
    gift_message_box_title_without_gifter_name: "Message",
    gift_message_box_title_with_gifter_name: "Message from {{gifter_name}}",
    payment_update_billing_agreement_popup_header: "Update payment method",
    payment_update_billing_agreement_popup_body:
        "Choose how you would like to update your payment details",
    payment_update_billing_agreement_popup_card_payment:
        "Switch to card based payment by adding the card details directly",
    payment_update_billing_agreement_popup_email_link:
        "Receive an email with secured link to choose between available payment methods",
    payment_update_billing_agreement_popup_confirm_button: "Confirm",
    payment_update_billing_agreement_popup_cancel_button: "Cancel",
    landing_page_title_without_gifter_name:
        "🎁 You received a gift subscription",
    landing_page_title_with_gifter_name:
        "🎁 You received a gift subscription from {{gifter_name}}",
    zapiet_time_picker_delivery_dropdown_label: "Select delivery time slot",
    zapiet_time_picker_pickup_dropdown_label: "Select pickup time",
    skip_order_limit_error_message:
        "You have already skipped maximum consecutive orders allowed.",
    partial_skip_drawer_header: "Skip order",
    partial_skip_drawer_text:
        "Choose the items you want to skip from your next order. If you remove a one-time added product, you\'ll need to add it back manually",
    partial_skip_selected_items_cta: "Skip selected items",
    skip_complete_order_cta: "Skip complete order",
    partial_skip_order_success_message: "Selected items have been skipped",
    loyalty_widget_btn_inf_io:
        "🎁 {{points}} Loyalty points | {{coupons}} coupons",
    loyalty_overview_points_title_inf_io: "Points available",
    loyalty_overview_drawer_header_inf_io: "Rewards for your commitments!",
    loyalty_overview_coupons_title_inf_io: "Coupons available",
    loyalty_overview_discount_btn_inf_io: "Redeem your discount rewards",
    loyalty_overview_discount_btn_subtitle_inf_io:
        "{{coupons}} coupons available",
    loyalty_overview_redeem_btn_inf_io: "Redeem your points",
    loyalty_overview_redeem_btn_subtitle_inf_io: "{{points}} points available",
    loyalty_overview_description_inf_io: "",
    loyalty_overview_drawer_go_back_btn_inf_io: "Go back",
    loyalty_overview_discount_non_subscription_discount_text_inf_io:
        "Non-subscription rewards",
    loyalty_overview_discount_subscription_discount_text_inf_io:
        "Subscription rewards",
    loyalty_points_drawer_points_redeemed_label_inf_io: "Points redeemed",
    loyalty_points_drawer_discount_description_inf_io:
        "Copy the code to enter during checkout",
    loyalty_discounts_drawer_apply_btn_inf_io: "Apply",
    loyalty_points_drawer_available_points_label_inf_io:
        "{{points}} points available",
    loyalty_points_drawer_bucket_points_label_inf_io: "{{points}} Point",
    loyalty_points_drawer_redeem_btn_inf_io: "Redeem",
    loyalty_points_drawer_go_back_btn_inf_io: "Go back",
    loyalty_discounts_drawer_header_inf_io: "Avail existing rewards",
    loyalty_discounts_available_coupons_text_inf_io:
        "{{coupons}} coupons available",
    loyalty_discounts_drawer_go_back_btn_inf_io: "Go back",
    loyalty_points_drawer_header_inf_io: "Redeem your points",
    loyalty_widget_btn_fb: "🎁 {{points}} Loyalty points | {{coupons}} coupons",
    loyalty_overview_points_title_fb: "Points available",
    loyalty_overview_drawer_header_fb: "Rewards for your commitments!",
    loyalty_overview_coupons_title_fb: "Coupons available",
    loyalty_overview_discount_btn_fb: "Redeem your discount rewards",
    loyalty_overview_discount_btn_subtitle_fb: "{{coupons}} coupons available",
    loyalty_overview_redeem_btn_fb: "Redeem your points",
    loyalty_overview_redeem_btn_subtitle_fb: "{{points}} points available",
    loyalty_overview_description_fb: "",
    loyalty_overview_drawer_go_back_btn_fb: "Go back",
    loyalty_points_drawer_points_redeemed_label_fb: "Points redeemed",
    loyalty_points_drawer_discount_description_fb:
        "Copy the code to enter during checkout",
    loyalty_discounts_drawer_apply_btn_fb: "Apply",
    loyalty_points_drawer_available_points_label_fb:
        "{{points}} points available",
    loyalty_points_drawer_bucket_points_label_fb: "{{points}} Point",
    loyalty_points_drawer_redeem_btn_fb: "Redeem",
    loyalty_points_drawer_go_back_btn_fb: "Go back",
    loyalty_discounts_drawer_header_fb: "Avail existing rewards",
    loyalty_discounts_available_coupons_text_fb:
        "{{coupons}} coupons available",
    loyalty_discounts_drawer_go_back_btn_fb: "Go back",
    loyalty_points_drawer_header_fb: "Redeem your points",
    upgradeFlowOfferBannerButton: "Show other offers",
    upgradeFlowPopupBody:
        "Are you sure you want to miss on additional savings?",
    upgradeFlowPopupConfirmCTA: "Miss the upgrade",
    upgradeFlowPopupHeader: "Miss the upgrade!",
    upgradeFlowPopupUpgradeButtonCTA: "Show me the offer",
    upgradeFlowOfferDrawerHeader: "Upgrades available",
    upgradeFlowOfferDrawerBody: "Choose an upgrade which suits you best:",
    upgradeFlowProfileDrawerCloseButtonCTA: "I will upgrade later!",
    upgradeFlowOfferDrawerButton: "Show me other offers",
    subscription_upgrade_success_message: "Subscription upgraded successfully!",
    upgradeFlowDrawerNewPackLabel: "New pack",
    upgradeFlowDrawerOldPackLabel: "Old pack",
    upgradeFlowDrawerSuccessMessageLabel: "Subscription upgraded successfully!",
    upgradeFlowOfferCloseButtonCTA: "Explore upgrades later",
    loyalty_widget_btn_yotpo: "{{points}} Loyalty points",
    loyalty_overview_journey_text_yotpo: "Your loyalty journey",
    loyalty_overview_journey_point_earned_text_yotpo:
        "Total points earned : {{points}}",
    loyalty_overview_view_history_btn_yotpo: "View history",
    loyalty_points_history_drawer_header_yotpo: "Rewards for your commitments!",
    loyalty_points_history_drawer_go_back_btn_yotpo: "Go back",
    loyalty_points_history_drawer_title_yotpo: "Points history",
    loyalty_points_history_drawer_points_label_yotpo: "{{points}} points",
    loyalty_overview_drawer_go_back_btn_yotpo: "Go back",
    loyalty_overview_drawer_header_yotpo: "Redeem points for rewards!",
    loyalty_overview_description_yotpo: "",
    loyalty_points_drawer_header_yotpo: "Redeem points for rewards!",
    loyalty_points_drawer_go_back_btn_yotpo: "Go back",
    loyalty_points_drawer_available_points_label_yotpo:
        "You have {{points}} points available",
    loyalty_points_drawer_redeem_btn_yotpo: "Get coupon code",
    loyalty_points_drawer_points_redeemed_label_yotpo: "Coupon code unlocked",
    loyalty_points_drawer_discount_description_yotpo:
        "Copy the code to enter at checkout",
    loyalty_points_drawer_bucket_points_label_yotpo: "{{points}} Points",
    loyalty_overview_redeem_btn_subtitle_yotpo: "{{points}} points available",
    loyalty_overview_redeem_btn_yotpo: "Redeem your points",
    loyalty_discounts_drawer_apply_btn_yotpo: "Apply",
    loyalty_overview_no_redemption_offer_available_yotpo: "",
    max_quantity_update_error_message:
        "The maximum allowable quantity is {{maximum_allowed_quantity}}.",
    product_card_free_item_label: "Free",
    miniStreakLabel: "Streaks",
    miniStreakCurrentStatusLabel:
        "{{currentOrderNumber}} of {{totalOrderNumber}} orders",
    miniStreakDueDateLabel: "You need to complete next order by {{dueDate}}",
    miniStreakDueDateWarningLabel:
        "Your streak will break if you fail to place the next order by {{dueDate}}",
    gift_instead_of_skip_modal_body: "Turn your upcoming order into a thoughtful gift - just choose Gift upcoming order and add their shipping details.",
    gift_instead_of_skip_modal_confirm_button: "Gift upcoming order",
    gift_instead_of_skip_modal_secondary_button: "Skip order",
    gift_instead_of_skip_modal_title: "Surprise someone instead of skipping",
    gift_instead_of_skip_order_button: "Gift order",
    gift_instead_of_skip_history_label: "Gift",
    swapProfileDrawerConfirmCTA: "Confirm swap",
    swapProfileDrawerHeader: "Product Swap",
    swapProfileDrawerBody: "",
    swapProfileDrawerChooseAnotherProductCTA: "Choose another product",
    swapProductShowOtherProductsCTA: "Show other swap options",
    swapProductConfirmCTA: "Confirm swap",
    swapProductCloseCTA: "Close",
    swapProductNewProductHeader: "New product",
    swapProfileDrawerCloseCTA: "Close",
    chooseNewProductSwapDrawer: "Choose new product",
    chooseOldProductSwapDrawer: "Choose old product",
    showNewProductDetailsSwapDrawer: "Show details",
    swapProductShowNewProductDetailsCTA: "Show details",
    swapProductHideNewProductDetailsCTA: "Hide details",
    hideNewProductDetailsSwapDrawer: "Hide details",
    add_multiple_products_campaign_action_list_header: "Limited time offer",
    quickActionSegmentDrawerUpdateButtonText: "Update card",
    quickActionSegmentDrawerBodyText: "Update your card and get incentive",
    quickActionSegmentDrawerHeaderText: "Update card",
    quickActionSegmentDrawerCloseButtonText: "Close",
    quickActionSegmentDrawerSuccessText: "Card updated successfully!",
};

export const defaultTefValues = {
    CP_THEME_ADVENT_LOYALTY_BBH: {
        loyalty_discounts_drawer_header: "Avail existing rewards",
        loyalty_discounts_available_coupons_text:
            "{{coupons}} coupons available",
        loyalty_discounts_drawer_go_back_btn: "Go back",
        loyalty_points_drawer_header: "Redeem your points",
        loyalty_points_drawer_available_points_label:
            "{{points}} points available",
        loyalty_points_drawer_go_back_btn: "Go back",
        loyalty_points_drawer_success_toast_msg:
            "Loyalty points redeemed successfully",
        loyalty_overview_bubblehouse_login_btn: "Go to my VIP rewards page",
        loyalty_overview_bubblehouse_login_btn_subtitle:
            "See my rewards history & ways to earn",
    },
    CP_THEME_ADVENT_LOYALTY_RIVO: {
        widget_btn: "{{points}} Loyalty points | {{coupons}} coupons",
        overview_drawer_header: "Rewards for your commitment!",
        overview_points_title: "Points available",
        overview_coupons_title: "Coupons available",
        overview_discount_btn: "Redeem your discount coupons",
        overview_discount_btn_subtitle: "{{coupons}} coupons available",
        overview_redeem_btn: "Redeem your points",
        overview_redeem_btn_subtitle: "{{points}} points available",
        overview_description: "",
        overview_drawer_go_back_btn: "Go back",
        points_drawer_header: "Redeem your points",
        points_drawer_available_points_label: "{{points}} points available",
        points_drawer_bucket_points_label: "{{points}} points",
        points_drawer_redeem_btn: "Redeem",
        points_drawer_go_back_btn: "Go back",
        points_drawer_points_redeemed_label: "Points redeemed",
        points_drawer_success_toast_msg: "Points redeemed successfully!",
        points_drawer_discount_description:
            "Copy the code to enter during checkout",
        discounts_drawer_apply_btn: "Apply",
        discounts_drawer_header: "Avail existing rewards",
        discounts_available_coupons_text: "{{coupons}} coupons available",
        discounts_subscription_discount_text: "Subscription rewards",
        discounts_onetime_discount_text: "Non-subscription rewards",
        discounts_drawer_go_back_btn: "Go back",
        available_offers_drawer_body_text:
            "Hey {{customer_first_name}}, we would hate to see you go! How about we change your mind with one of these offers?",
    },
    CP_THEME_ADVENT_LOYALTY_RISEAI: {
        widget_btn: "💰{{credits}} store credits",
        overview_drawer_header: "Redeem points for rewards!",
        overview_points_btn: "Redeem store credits",
        overview_points_btn_subtitle: "{{credits}} store credits available",
        overview_description: "",
        overview_drawer_go_back_btn: "Go back",
        points_drawer_header: "Redeem points for rewards!",
        points_drawer_available_credits_label:
            "You have {{credits}} credits available",
        points_drawer_slider_description:
            "Use the slider to exchange credits for store discount.",
        points_drawer_selected_label: "{{credits}}",
        points_drawer_redeem_btn: "Apply",
        points_drawer_description: "",
        points_drawer_go_back_btn: "Go back",
        points_drawer_success_toast_msg: "Store credits applied successfully",
        overview_history_btn: "View history",
        history_drawer_header: "Rewards for your commitment!",
        history_drawer_title: "Credits history",
        history_drawer_go_back_btn: "Go back",
    },
    CP_THEME_ADVENT_LOYALTY_OKENDO: {
        widget_btn: "{{points}} Loyalty Points | {{coupons}} coupons",
        overview_drawer_header: "Rewards for your commitment!",
        overview_points_title: "Points available",
        overview_coupons_title: "Coupons available",
        overview_discount_btn: "Redeem your discount coupons",
        overview_discount_btn_subtitle: "{{coupons}} coupons available",
        overview_redeem_btn: "Redeem your points",
        overview_redeem_btn_subtitle: "{{points}} points available",
        overview_description: "",
        overview_drawer_go_back_btn: "Go back",
        points_drawer_header: "Redeem your points",
        points_drawer_available_points_label: "{{points}} points available",
        points_drawer_rule_header: "{{value}} off coupon",
        points_drawer_rule_subtitle: "{{points}} points",
        points_drawer_redeem_btn: "Apply",
        points_drawer_go_back_btn: "Go back",
        points_drawer_success_toast_msg: "Points redeemed successfully!",
        discounts_drawer_header: "Avail existing rewards",
        discounts_available_coupons_text: "{{coupons}} coupons available",
        discounts_subscription_discount_text: "Subscription discounts",
        discounts_onetime_discount_text: "One-time discounts",
        discounts_drawer_go_back_btn: "Go back",
    },

    CP_THEME_ADVENT_LOYALTY_YOTPO: {
        points_drawer_success_toast_msg: "Points redeemed successfully!",
    },
    CP_THEME_ADVENT_LOYALTY_INF_IO: {
        points_drawer_success_toast_msg: "Points redeemed successfully!",
    },
};

export default defaultTranslations;
